var ajaxResponseBaseTime = 3;
var ajaxResponseRequestError = "<div class='message error icon-warning'>Desculpe mas não foi possível processar sua requisição...</div>";

$(function () {

    /**
     * AJAX FORM SUBMIT
     */
    $("form:not('.ajax_off')").submit(function (e) {
        e.preventDefault();
        var form = $(this);
        var load = $(".ajax-load");
        var flashClass = "ajax_response";
        var flash = $("." + flashClass);

        form.ajaxSubmit({
            url: form.attr("action"),
            type: "POST",
            dataType: "json",
            beforeSend: () => {
                loaderShow();
            },
            success: (response) => {
                //redirect
                if (response.redirect) {
                    window.location.href = response.redirect;
                } else {
                    loaderClose();
                }

                //message
                if (response.message) {
                    if (flash.length) {
                        //flash.html(response.message).fadeIn(100).effect("bounce", 300);
                        flash.html(response.message).fadeIn(100);
                    } else {
                        form.prepend("<div class='" + flashClass + "'>" + response.message + "</div>")
                            .find("." + flashClass);
                    }
                } else {
                    loaderClose();
                }
            },
            complete: function () {
                if (form.data("reset") === true) {
                    form.trigger("reset");
                }
            }
        });
    });

    /**
     * DATA- POST
     */
    $("body").on("click", "[data-post]", function(e) {
        e.preventDefault();

        var clicked = $(this);
        var data = clicked.data();
        var flashClass = "ajax_response";
        var flash = $("." + flashClass);

        if (data.confirm) {
            Swal.fire({
                title: data.confirm,
                icon: "question",
                showCancelButton: true,
                confirmButtonColor: "#90cb22",
                confirmButtonText: "Sim",
                cancelButtonColor: "#9ca8b3",
                cancelButtonText: "Não"
            }).then((result) => {
                if (result.value) {

                    $.ajax({
                        url: data.post,
                        type: "POST",
                        data: data,
                        dataType: "json",
                        beforeSend: () => {
                            loaderShow();
                        },
                        success: (response) => {
                            //redirect
                            if (response.redirect) {
                                window.location.href = response.redirect;
                            } else {
                                loaderClose();
                            }

                            //reload
                            if (response.reload) {
                                window.location.reload();
                            } else {
                                loaderClose();
                            }

                            //message
                            if (response.message) {
                                flash.html(response.message).fadeIn(100);
                            }
                        },
                        error: function () {
                            flash.html(ajaxResponseRequestError).fadeIn(100);
                            loaderClose();
                        }
                    });

                }
            });
        }
    });


});